import { dummyFanActivity } from './audience'
import type { FanActivity } from '@/store/modules/customer/types.ts'
import type { Activity } from '@/types/resources/activity.ts'

/**
 * Returns customer activity data based on feature enablement and activity type
 * @param {boolean} isCustomerProfileFeatureEnabled - Whether customer profiles feature is enabled
 * @param {string} interactiveListIndex - The type of activity to filter by
 * @param {Array} fanActivity - The customer's activity data
 * @returns {Array} - The filtered activity data in API format
 */

export function getComputedActivity(
  isCustomerProfileFeatureEnabled: boolean,
  interactiveListIndex: string,
  fanActivity: FanActivity[],
): Activity[] {
  if (!isCustomerProfileFeatureEnabled) {
    // Return dummy data formatted in the API format
    const dummyActivities = dummyFanActivity(interactiveListIndex)
    return dummyActivities.map(activity => ({
      oid: activity.oid,
      activityType: activity.type[0], // Use the first type as activityType
      activityTime: activity.datetime,
      additionalInfo: {
        messageBody: activity.title,
        provider: activity.type.includes('sms') ? 'sms' : 'email',
        status: activity.type.includes('unsubscribed') ? 'unsubscribed' : 'sent',
      },
      fanPromoterAccount: {
        oid: 123,
        firstName: 'Demo',
        lastName: 'User',
        emailAddress: 'demo@example.com',
      },
    }))
  }

  // For real data, convert from fan-activity.json format to API format
  if (!fanActivity || !Array.isArray(fanActivity)) return []

  const processedActivities: Activity[] = fanActivity

  // fanActivity.forEach((activity) => {
  //   // Convert the FanActivity to Activity format
  //   const convertedActivity: Activity = {
  //     oid: activity.oid,
  //     activityType: activity.activityType as Activity['activityType'],
  //     activityTime: new Date(activity.activityTime),
  //     dateTime: activity.activityTime,
  //     sysCtime: new Date(activity.sysCtime),
  //     activityResourceOid: activity.activityResourceOid,
  //     eventOid: activity.eventOid,
  //     fanOid: activity.fanOid,
  //     purchaseOid: null,
  //     campaignOid: activity.campaignOid,
  //     additionalInfo: activity.additionalInfo,
  //     fanPromoterAccount: {
  //       oid: activity.fanPromoterAccount.oid,
  //       firstName: activity.fanPromoterAccount.firstName,
  //       lastName: activity.fanPromoterAccount.lastName,
  //       emailAddress: activity.fanPromoterAccount.emailAddress,
  //       additionalInfo: {},
  //     },
  //   }
  //   processedActivities.push(convertedActivity)
  // })

  // Sort all activities by activityTime in descending order (newest first)
  return processedActivities.sort((a, b) => {
    const timeA = new Date(a.activityTime).getTime()
    const timeB = new Date(b.activityTime).getTime()
    return timeB - timeA
  })
}
